import { Backdrop, CircularProgress } from '@mui/material';

interface IProps {
  open?: boolean;
}

const ModalLoadingBackdrop = ({ open }: IProps) => {
  return (
    <Backdrop
      sx={theme => ({
        color: 'white',
        zIndex: theme.zIndex.modal + 1,
      })}
      open={!!open}
    >
      <CircularProgress color='inherit' />
    </Backdrop>
  );
};
export default ModalLoadingBackdrop;
